import React, { useEffect, useState } from "react";
import { filterSelectData, getDefaultOptionSelect, selectProductCategoryVinci, selectProductGroupVinci } from "../../../service/comboBox";
import validate from "../../../validate-forms/ProductSubGroupVinci/AddFormValidationRules";
import { createRecord, editRecord } from "../../../request/Request";
import useForm from "../../../validate-forms/useForm";
import { ErrorPage } from "../../ErrorPage/ErrorPage";
import { Loading } from "../../Loading/Loading";
import { ComboBox } from "../../ComboBox/ComboBox";
import './AddOrEdit.css';
import Warning from "../../Notification/Warning";
import { productSubGroupVinciErrors } from "../../../service/ErrorNotification/productSubGroupVinciErrors";
import { selectEnable, typeFilterSelect } from "../../../service/defaultData";

export const AddOrEdit = ({ actionChange, createdOrEditSubGroup, subGroup, render }) => {

    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(false);
    const [errorMessageProductGroupsVinci, setErrorMessageProductGroupsVinci] = useState('');

    const [defaultEnable, setDefaultEnable] = useState(null);
    const [defaultCategoryVinci, setDefaultCategoryVinci] = useState(null);
    const [defaultGroupVinci, setDefaultGroupVinci] = useState(null);

    const [productGroupsVinci, setProductGroupsVinci] = useState([]);
    const [productCategoriesVinci, setProductCategoriesVinci] = useState([]);
    const [productCategoriesVinciFiltered, setProductCategoriesVinciFiltered] = useState([]);

    const [statusPetitionProductGroupsVinci, setStatusPetitionProductGroupsVinci] = useState(false);
    const [statusPetitionProductCategoriesVinci, setStatusPetitionProductCategoriesVinci] = useState(false);

    const [resetProductGroupsVinci, setResetProductGroupsVinci] = useState(false);
 
    const [statusButton, setStatusButton] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');

    const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

    useEffect(() => {
        (async function () {

            setStatusPetitionProductCategoriesVinci(true);
            const productCategoriesVinci = await selectProductCategoryVinci();

            if (productCategoriesVinci.statusResponse) {
                setProductCategoriesVinci(productCategoriesVinci.data);
                setStatusPetitionProductCategoriesVinci(false);

            } else {
                setStatusPetitionProductCategoriesVinci(false);
                setErrorMessage(true);
                setLoading(false);
            }

        })();
    }, []);

    useEffect(() => {

        if (render === 'add') {
            let enabledCategoriesVinci = filterSelectData(typeFilterSelect.add, productCategoriesVinci);
            setProductCategoriesVinciFiltered(enabledCategoriesVinci);
            setLoading(false);
        } else {

            if (productCategoriesVinci.length > 0) {

                values.enable = subGroup.enable;
                values.subgroup_name = subGroup.subgroup_name;
                values.id_vinci_product_group = subGroup.id_vinci_product_group;
                values.id_vinci_product_category = subGroup.id_vinci_product_category;

                let defaultEnabledTemp = getDefaultOptionSelect(selectEnable, subGroup.enable);
                setDefaultEnable(defaultEnabledTemp[0]);

                (async function () {

                    let defaultProductCategoryVinciTemp = getDefaultOptionSelect(productCategoriesVinci, subGroup.id_vinci_product_category);
                    (defaultProductCategoryVinciTemp.length > 0) ? setDefaultCategoryVinci(defaultProductCategoryVinciTemp[0]) : setDefaultCategoryVinci([]);

                    let enabledAndDisabledProductCategoriesVinci = filterSelectData(typeFilterSelect.edit, productCategoriesVinci, defaultProductCategoryVinciTemp);
                    setProductCategoriesVinciFiltered(enabledAndDisabledProductCategoriesVinci);

                    if (productGroupsVinci.length === 0) {

                        const productCategoriesVinci = await selectProductGroupVinci(defaultProductCategoryVinciTemp[0]?.value);
                        if (productCategoriesVinci.statusResponse && !defaultGroupVinci) {

                            let defaultProductGroupVinciTemp = getDefaultOptionSelect(productCategoriesVinci.data, subGroup.id_vinci_product_group);
                            (defaultProductGroupVinciTemp.length > 0) ? setDefaultGroupVinci(defaultProductGroupVinciTemp[0]) : setDefaultGroupVinci([]);

                            let enabledGroupsVinci = filterSelectData(typeFilterSelect.edit, productCategoriesVinci.data, defaultProductGroupVinciTemp);
                            setProductGroupsVinci(enabledGroupsVinci);

                        }
                    }

                })();

            }

        }
    }, [productCategoriesVinci])

    useEffect(() => {
        if (defaultCategoryVinci && defaultGroupVinci && defaultEnable && render == 'edit') {
            setLoading(false);
        }

    }, [defaultCategoryVinci, defaultGroupVinci, defaultEnable])

    async function sendForm() {
        setWarningMessage('');
        setStatusButton(true);
        if (render === 'add') {
            await createRecord(`/vinciproductsubgroup`, values).then(request => {
                setStatusButton(false);
                if (request.statusResponse) {
                    redirect('created');
                }
            }).catch(error => getErrors(error));
        } else {
            await editRecord(`/vinciproductsubgroup/${subGroup.id_vinci_product_subgroup}`, values).then(request => {
                setStatusButton(false);
                if (request.statusResponse) {
                    redirect('edit');
                }
            }).catch(error => getErrors(error));
        }
    }

    const getErrors = (error) => {

        setWarningMessage('');
        setErrorMessage(false);

        let respondeError = productSubGroupVinciErrors(error);

        if (respondeError === 'error') return setErrorMessage(true);

        setWarningMessage(respondeError);
        setStatusButton(false);

    }

    const redirect = (action) => {
        createdOrEditSubGroup(action);
        actionChange('table');
    }

    const getProductGroupsVinci = async (id_vinci_product_category) => {

        if (id_vinci_product_category !== values.id_vinci_product_category) {
            setResetProductGroupsVinci(false);
            setStatusPetitionProductGroupsVinci(true);
            const productGroupVinci = await selectProductGroupVinci(id_vinci_product_category);
            if (productGroupVinci.statusResponse) {

                setResetProductGroupsVinci(true);
                setErrorMessageProductGroupsVinci('');

                let productGroupsVinciEnabled = filterSelectData(typeFilterSelect.add, productGroupVinci.data);
                setProductGroupsVinci(productGroupsVinciEnabled);

                setStatusPetitionProductGroupsVinci(false);
            } else {

                setStatusPetitionProductGroupsVinci(false);
                setErrorMessageProductGroupsVinci('La categoría de vinci no posee grupos de vinci relacionados');

                setProductGroupsVinci([]);
                setResetProductGroupsVinci(true);
            }
        }

    }

    function comboBoxChange(e) {
        handleChange(e);
        if (e.target.name === 'id_vinci_product_category') {
            getProductGroupsVinci(e.target.value)
        }
    }

    return loading ? <Loading /> : errorMessage ? <ErrorPage redirect={true} actionChange={actionChange} name={'Sub-Grupo de Productos Vinci'} /> :
        <section className="section form-color">
            <form onSubmit={handleSubmit} noValidate>
                <div className="acction-card"><span aria-hidden="true">
                    {render === 'add' ? 'Agregar ' : 'Actualizar '} Sub-Grupo</span>
                </div>

                {warningMessage !== '' && <Warning text={warningMessage} />}

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group coriport-input">
                            <label htmlFor="subgroup_name" className="form-label">Nombre del Sub-Grupo</label>
                            <input
                                type="text"
                                className={`input-form form-control ${errors.subgroup_name && 'is-danger'}`}
                                placeholder="Nombre del Sub-Grupo"
                                name="subgroup_name"
                                onChange={handleChange}
                                value={values.subgroup_name || ''}
                                required
                            />
                            {errors.subgroup_name && (<p className="help is-danger">{errors.subgroup_name}</p>)}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group coriport-input">
                            <ComboBox
                                name={"id_vinci_product_category"}
                                text={"Categoría de Productos Vinci"}
                                options={productCategoriesVinciFiltered}
                                onChange={comboBoxChange}
                                isLoading={statusPetitionProductCategoriesVinci}
                                defaultValueSelect={defaultCategoryVinci}
                            />
                            {errors.id_vinci_product_category && (<p className="help is-danger">{errors.id_vinci_product_category}</p>)}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group coriport-input">
                            <ComboBox
                                name={"id_vinci_product_group"}
                                text={"Grupo de Productos Vinci"}
                                options={productGroupsVinci}
                                onChange={comboBoxChange}
                                isLoading={statusPetitionProductGroupsVinci}
                                resetSelect={resetProductGroupsVinci}
                                defaultValueSelect={defaultGroupVinci}
                            />
                            {errors.id_vinci_product_group && (<p className="help is-danger">{errors.id_vinci_product_group}</p>)}
                            {errorMessageProductGroupsVinci && (<p className="help is-danger">{errorMessageProductGroupsVinci}</p>)}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group coriport-input">
                            <ComboBox
                                name={"enable"}
                                text={"Estado"}
                                options={selectEnable}
                                onChange={comboBoxChange}
                                defaultValueSelect={defaultEnable}
                            />
                            {errors.enable && (<p className="help is-danger">{errors.enable}</p>)}
                        </div>
                    </div>
                </div>

                <div className="container-bottons">
                    <button disabled={statusButton} id='custom-btn-coriport' className=" btn  btn-coriport btn-add text-white " type="submit">
                        {
                            statusButton ? <div className="container-spinner-loading pt-2">
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </div> : <p className="label-button-add"> {render == 'add' ? 'Agregar' : 'Actualizar'}</p>
                        }
                    </button>
                    <button className="btn-coriport btn-cancel" onClick={() => actionChange('table')}>
                        Cancelar
                    </button>
                </div>

            </form>
        </section>

}